export default __webpack_public_path__ + "static/media/6.1c5c5a4e.jpg";